import React from "react";
import { useNavigate } from "react-router-dom";
export default function AllPhotosUploaded({ numberOfPhotosUploaded }) {
  const navigate = useNavigate();
  return (
    <div className="ch-bg--grey-2 all-photos-uploaded-container">
      <div className="upload-check ch-circle ch-ba--2 ch-bc--ac-green" />
      <p
        className="ch-text--center ch-mb--0 ch-fs--3"
        data-testid="successful-message"
      >
        You've successfully
        <br />
        uploaded{" "}
        <button
          className="ch-btn--link ch-ph--0"
          onClick={() => navigate("/photo-gallery")}
        >
          {numberOfPhotosUploaded} photos.
        </button>
      </p>
    </div>
  );
}
